import React from 'react';
import { Particles } from './Particles';
import { CHECKOUT_URL } from '../data/salesContent';
import { trackAddToCart } from '../utils/metaPixel';
export function Hero() {
  return <section className="relative overflow-hidden px-5 py-14 sm:px-8 lg:py-16" style={{
    background: 'linear-gradient(160deg, #1a1a1a 0%, #2d1b4e 100%)'
  }} data-id="element-55" data-mp="9kjxsrx55a59">
      <Particles data-id="element-56" data-mp="4jm69oq8r3r3" />

      <div className="relative mx-auto grid max-w-6xl items-center gap-10 lg:grid-cols-[1.15fr_0.85fr]" data-id="element-57" data-mp="129h0vnss70df">
        <div className="text-center lg:text-left" data-id="element-58" data-mp="xanojyp8dfeu">
          <span className="inline-block rounded-full border border-gold/50 px-3 py-1 text-[10px] font-bold uppercase tracking-[0.14em] text-gold sm:text-[11px]" data-id="element-59" data-mp="xaxexne6tol2">
            Medicina Integrativa · Cristales · Hierbas · Numerología
          </span>

          <h1 className="mt-5 font-display text-[30px] font-bold leading-[1.14] text-white sm:text-[38px] lg:text-[48px]" data-id="element-60" data-mp="3d1aa1ojbgjfe">
            Elimina hasta 80 Tipos de Dolor Psicosomático en 7 Minutos al Día
            <span className="block text-gold" data-id="element-61" data-mp="3j8sg632wlnqw">Sin Fármacos ni Experiencia Previa</span>
          </h1>

          <p className="mx-auto mt-4 max-w-xl text-[15px] leading-relaxed text-gold sm:text-[18px] lg:mx-0" data-id="element-62" data-mp="3o85cdefo0765">
            El manual práctico de autosanación energética que te enseña a leer el lenguaje de tu
            cuerpo y sanar desde la raíz — incluso si los médicos te dijeron que solo es estrés.
          </p>

          <div className="mt-7" data-id="element-63" data-mp="30gzwx0dmzgwd">
            <a href={CHECKOUT_URL} onClick={() => trackAddToCart()} className="cta-pulse inline-block w-full rounded-xl border-2 border-gold bg-emerald-deep px-6 py-4 text-center text-[14px] font-black uppercase tracking-wide text-white transition-colors duration-200 ease-out hover:bg-[#215c39] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gold sm:w-auto sm:text-[16px]" data-id="element-64" data-mp="30gq5r9guv3p3">
              ✅ Quiero mi acceso completo — $9.99 USD
            </a>
            <p className="mt-3 text-[12px] text-white/65" data-id="element-65" data-mp="s2jj7lrcvge8">
              🔒 Pago seguro · PDF descargable al instante · Garantía 7 días
            </p>
          </div>

          <ul className="mt-6 flex flex-wrap items-center justify-center gap-x-6 gap-y-2 border-t border-white/10 pt-5 text-[12px] font-bold text-white/85 lg:justify-start sm:text-[13px]" data-id="element-66" data-mp="n9i7fmmg3wyv">
            <li data-id="element-67" data-mp="db2fjhflgjob">⭐ 4.9/5 valoración</li>
            <li aria-hidden="true" className="text-white/20" data-id="element-68" data-mp="1b1fcmuve3qr0">|</li>
            <li data-id="element-69" data-mp="1ayjhfeaxfg69">👩 +2,400 lectoras</li>
            <li aria-hidden="true" className="text-white/20" data-id="element-70" data-mp="161jbr4hzoffo">|</li>
            <li data-id="element-71" data-mp="112pud0zl04a8">✅ Garantía 7 días</li>
          </ul>
        </div>

        <div className="relative" data-id="element-72" data-mp="110wohnwslo3a">
          <img src="https://cdn.magicpatterns.com/uploads/pdBsSCKjCK6bfoEaC6HTvV/PORTADA_-_MANUAL_DE_LA_AUTOSANACION_ENERGETICA.png" alt="Portada del ebook Manual de la Autosanación Energética" className="mx-auto w-full max-w-[320px] rounded-lg border border-gold/40 shadow-[0_24px_60px_-24px_rgba(201,168,76,0.55)] lg:max-w-none" data-id="element-73" data-mp="x14ldqq64a5b" />
        </div>
      </div>
    </section>;
}